import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { CaretDoubleUp, DotsThree } from "@phosphor-icons/react";
import { useState } from "react";
const LeftMessage = ({ message, name, date, maxCharacters, }) => {
    const [showFullText, setShowFullText] = useState(false);
    const toggleTextVisibility = () => {
        setShowFullText(!showFullText);
    };
    const truncatedText = showFullText
        ? message
        : message.slice(0, maxCharacters);
    return (_jsxs(Grid, { container: true, size: 12, className: "leftmessage", children: [_jsx(Grid, { size: 2, children: _jsx(Avatar, {}) }), _jsxs(Grid, { container: true, size: 12, className: "content", children: [_jsxs(Grid, { className: "namecontainer", children: [_jsx(Typography, { className: "nametext", children: name }), _jsx(Typography, { className: "datetext", children: date })] }), _jsxs(Grid, { children: [_jsx(Typography, { className: "message", children: truncatedText }), message.length > maxCharacters &&
                                (showFullText ? (_jsx(CaretDoubleUp, { onClick: toggleTextVisibility, children: " " })) : (_jsx(DotsThree, { onClick: toggleTextVisibility })))] })] })] }));
};
export default LeftMessage;
